import { defineMessages } from 'react-intl';

export const rolesMessages = defineMessages({
    name: {
        id: 'name',
        defaultMessage: 'Name',
    },
    role: {
        id: 'role',
        defaultMessage: 'Role',
    },
    roles: {
        id: 'roles',
        defaultMessage: 'Roles',
    },
    editRole: {
        id: 'edit-role',
        defaultMessage: 'Edit role',
    },
    addRole: {
        id: 'add-role',
        defaultMessage: 'Add role',
    },
    addRoleSubtitle: {
        id: 'add-role-subtitle',
        defaultMessage: 'Add new role',
    },
    editRoleSubtitle: {
        id: 'edit-role-subtitle',
        defaultMessage: 'Edit role {entry}',
    },
    deleteRoleSubtitle: {
        id: 'delete-role-subtitle',
        defaultMessage: 'Permanently delete role {entry}',
    },
    confirmDeleteRole: {
        id: 'confirm-delete-role',
        defaultMessage: 'Are you sure you want to delete role {entry}? This action cannot be undone.',
    },
    createRoleSuccessDescription: {
        id: 'create-role-success-description',
        defaultMessage: 'Role {entry} has been successfully created.',
    },
    updateRoleSuccessDescription: {
        id: 'update-role-success-description',
        defaultMessage: 'Role {entry} has been successfully updated.',
    },
    deleteRoleSuccessDescription: {
        id: 'delete-role-success-description',
        defaultMessage: 'Role {entry} has been successfully deleted.',
    },
    createRoleSuccess: {
        id: 'create-role-success',
        defaultMessage: 'Role created',
    },
    updateRoleSuccess: {
        id: 'update-role-success',
        defaultMessage: 'Role updated',
    },
    deleteRoleSuccess: {
        id: 'delete-role-success',
        defaultMessage: 'Role deleted',
    },
    dashboard: {
        id: 'dashboard',
        defaultMessage: 'Dashboard',
    },
    manageRoles: {
        id: 'manage-roles',
        defaultMessage: 'Manage roles',
    },
    accessUsers: {
        id: 'access-users',
        defaultMessage: 'Access users',
    },
    manageUsers: {
        id: 'manage-users',
        defaultMessage: 'Manage users',
    },
    entities: {
        id: 'entities',
        defaultMessage: 'Entities',
    },
    sites: {
        id: 'sites',
        defaultMessage: 'Sites',
    },
    users: {
        id: 'users',
        defaultMessage: 'Users',
    },
    saveChanges: {
        id: 'save-changes',
        defaultMessage: 'Save changes',
    },
    rolePermissionsChangesSuccess: {
        id: 'role-permissions-changes-success',
        defaultMessage: 'The permissions for role {entry} were successfully changed',
    },
    rolePermissionsChanged: {
        id: 'role-permissions-changed',
        defaultMessage: 'Role permissions changed',
    },
    backToAllRoles: {
        id: 'back-to-all-roles',
        defaultMessage: 'Back to all roles',
    },
    billingEntities: {
        id: 'billing-entities',
        defaultMessage: 'Billing entities',
    },
    payments: {
        id: 'payments',
        defaultMessage: 'Payments',
    },
    accessCharges: {
        id: 'access-charges',
        defaultMessage: 'Access charges',
    },
    manageCharges: {
        id: 'manage-charges',
        defaultMessage: 'Manage charges',
    },
    accessCustomers: {
        id: 'access-customers',
        defaultMessage: 'Access customers',
    },
    manageCustomers: {
        id: 'manage-customers',
        defaultMessage: 'Manage customers',
    },
    accessBillingEntities: {
        id: 'access-billing-entities',
        defaultMessage: 'Access billing entities',
    },
    manageBillingEntities: {
        id: 'manage-billing-entities',
        defaultMessage: 'Manage billing entities',
    },
    accessDiscounts: {
        id: 'access-discounts',
        defaultMessage: 'Access discounts',
    },
    manageDiscounts: {
        id: 'manage-discounts',
        defaultMessage: 'Manage discounts',
    },
    accessVouchers: {
        id: 'access-vouchers',
        defaultMessage: 'Access vouchers',
    },
    manageVouchers: {
        id: 'manage-vouchers',
        defaultMessage: 'Manage vouchers',
    },
    accessFinancialDocuments: {
        id: 'access-financial-documents',
        defaultMessage: 'Access financial documents',
    },
    manageFinancialDocuments: {
        id: 'manage-financial-documents',
        defaultMessage: 'Manage financial documents',
    },
    issueFinancialDocuments: {
        id: 'issue-financial-documents',
        defaultMessage: 'Issue financial documents',
    },
    accessUnits: {
        id: 'access-units',
        defaultMessage: 'Access units',
    },
    manageUnits: {
        id: 'manage-units',
        defaultMessage: 'Manage units',
    },
    accessAccountingRanges: {
        id: 'access-accounting-ranges',
        defaultMessage: 'Access accounting ranges',
    },
    manageAccountingRanges: {
        id: 'manage-accounting-ranges',
        defaultMessage: 'Manage accounting ranges',
    },
    accessAccountingHeadings: {
        id: 'access-accounting-headings',
        defaultMessage: 'Access accounting headings',
    },
    manageAccountingHeadings: {
        id: 'manage-accounting-headings',
        defaultMessage: 'Manage accounting headings',
    },
    accessPayments: {
        id: 'access-payments',
        defaultMessage: 'Access payments',
    },
    managePayments: {
        id: 'manage-payments',
        defaultMessage: 'Manage payments',
    },
    accessServicePlans: {
        id: 'access-service-plans',
        defaultMessage: 'Access service plans',
    },
    manageServicePlans: {
        id: 'manage-service-plans',
        defaultMessage: 'Manage service plans',
    },
    accessSubscriptions: {
        id: 'access-subscriptions',
        defaultMessage: 'Access subscriptions',
    },
    manageSubscriptions: {
        id: 'manage-subscriptions',
        defaultMessage: 'Manage subscriptions',
    },
    accessTaxReasons: {
        id: 'access-tax-reasons',
        defaultMessage: 'Access tax reasons',
    },
    manageTaxReasons: {
        id: 'manage-tax-reasons',
        defaultMessage: 'Manage tax reasons',
    },
    accessMoneyAccounts: {
        id: 'access-money-accounts',
        defaultMessage: 'Access money accounts',
    },
    manageMoneyAccounts: {
        id: 'manage-money-accounts',
        defaultMessage: 'Manage money accounts',
    },
    accessRoles: {
        id: 'access-roles',
        defaultMessage: 'Access roles',
    },
});
